export enum CalendarModalTestID {
  Container = 'CalendarModalTestID.Container',
  AddCalendarButton = 'CalendarModalTestID.AddCalendarButton',
  CalendarName = 'CalendarModalTestID.CalendarName',
  CheckForConflictsSwitch = 'CalendarModalTestID.CheckForConflictsSwitch',
  AddToCalendarSwitch = 'CalendarModalTestID.AddToCalendarSwitch',
  CloseButton = 'CalendarModalTestID.CloseButton',
  ContinueDoneButton = 'CalendarModalTestID.ContinueDoneButton',
  ModalInfo = 'CalendarModalTestID.CalendarModalInfoText',
  ProfileView = 'CalendarModalTestID.CalendarModalProfileView',
  ActionButtonsGroup = 'CalendarModalTestID.CalendarModalActionButtonsGroup',
  DeleteButton = 'CalendarModalTestID.DeleteButton',
  ResyncButton = 'CalendarModalTestID.ResyncButton',
  ProfileCard = 'CalendarModalTestID.ProfileCard',
  GettingStartedTitle = 'CalendarModalTestID.GettingStartedTitle',
  DeletedToZeroView = 'CalendarModalTestID.DeletedToZeroView',
  ConfirmDeleteView = 'CalendarModalTestID.ConfirmDeleteView',
  ConfirmDeleteTitle = 'CalendarModalTestID.ConfirmDeleteTitle',
  CancelButton = 'CalendarModalTestID.CancelButton',
}

export enum CalendarModalBannerIcon {
  ErrorX = 'errorCircle',
  CheckCircle = 'checkCircle',
  Trashcan = 'bannerDeleteIcon',
  SyncCircle = 'syncingCircle',
}

export interface CalendarState {
  isActive: boolean;
  isTarget: boolean;
}

export interface DeleteCalendarData {
  profileId: string;
  uuid: string;
  profileName: string;
}
